import React, { useState, useEffect } from 'react';

const styles = {
  nav: (scrolled) => ({
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 300,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    padding: scrolled ? '0.6rem 3rem' : '1.1rem 3rem',
    background: scrolled ? 'rgba(242,232,217,0.97)' : 'transparent',
    backdropFilter: scrolled ? 'blur(14px)' : 'none',
    borderBottom: scrolled ? '1px solid rgba(201,168,76,0.3)' : 'none',
    transition: 'all 0.45s ease',
    boxShadow: scrolled ? '0 2px 24px rgba(42,31,14,0.08)' : 'none',
  }),
  brand: { display: 'flex', alignItems: 'center', gap: '0.75rem' },
  hotelName: (scrolled) => ({
    fontFamily: "'Cinzel', serif", fontSize: '0.88rem', letterSpacing: '2px',
    color: scrolled ? '#1B2F6E' : '#C9A84C', lineHeight: '1.2',
    transition: 'color 0.4s',
  }),
  tagline: (scrolled) => ({
    fontFamily: "'Jost', sans-serif", fontSize: '0.5rem', letterSpacing: '4px',
    textTransform: 'uppercase', fontWeight: 300,
    color: scrolled ? 'rgba(27,47,110,0.55)' : 'rgba(201,168,76,0.65)',
    transition: 'color 0.4s',
  }),
  links: { display: 'flex', gap: '2.2rem', listStyle: 'none' },
  link: (scrolled) => ({
    fontFamily: "'Jost', sans-serif", fontSize: '0.6rem', letterSpacing: '3px',
    textTransform: 'uppercase', fontWeight: 400,
    color: scrolled ? 'rgba(27,47,110,0.8)' : 'rgba(242,232,217,0.88)',
    cursor: 'pointer', transition: 'color 0.3s', border: 'none', background: 'none',
  }),
  cta: (scrolled) => ({
    background: '#C9A84C', color: '#0F1D48',
    fontFamily: "'Jost', sans-serif", fontSize: '0.58rem', letterSpacing: '3px',
    textTransform: 'uppercase', padding: '0.6rem 1.4rem',
    border: 'none', cursor: 'pointer', fontWeight: 500, transition: 'all 0.3s',
  }),
  hamburger: (scrolled) => ({
    display: 'none', flexDirection: 'column', gap: '5px', background: 'none',
    border: 'none', cursor: 'pointer', padding: '4px',
  }),
};

const navLinks = [
  ['Rooms', 'rooms'], ['Amenities', 'amenities'], ['Nearby', 'nearby'],
  ['Gallery', 'gallery'], ['Location', 'location'],
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 70);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const go = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <>
      <style>{`
        @media(max-width:860px){
          .nav-links-wrap { display: none !important; }
          .nav-cta-btn { display: none !important; }
          .nav-hamburger { display: flex !important; }
        }
        .nav-link-item:hover { color: #C9A84C !important; }
        .nav-cta-btn:hover { background: #E8C97A !important; }
        .mobile-menu { position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(242,232,217,0.98);
          z-index:299;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2rem; }
        .mobile-link { font-family:'Cinzel',serif;font-size:1.4rem;color:#1B2F6E;letter-spacing:3px;
          cursor:pointer;transition:color .3s; }
        .mobile-link:hover { color:#C9A84C; }
        .mobile-close { position:absolute;top:1.5rem;right:1.5rem;font-size:1.5rem;
          background:none;border:none;cursor:pointer;color:#1B2F6E;font-family:'Jost',sans-serif; }
      `}</style>

      <nav style={styles.nav(scrolled)}>
        <div style={styles.brand}>
          {/* <svg width="38" height="38" viewBox="0 0 120 120" fill="none">
            <circle cx="60" cy="60" r="55" stroke="#C9A84C" strokeWidth="1.2" fill="none" opacity=".45"/>
            {[...Array(14)].map((_,i)=>{
              const a=(i*25.7-90)*Math.PI/180, r1=35, r2=50;
              return <line key={i} x1={60+r1*Math.cos(a)} y1={60+r1*Math.sin(a)} x2={60+r2*Math.cos(a)} y2={60+r2*Math.sin(a)} stroke="#C9A84C" strokeWidth="1.5" opacity=".65"/>;
            })}
            <path d="M24 76 Q60 92 96 76" fill="#1B2F6E" opacity=".9"/>
            {[[-16,2],[−8,-12],[8,-12],[16,2],[10,14],[-10,14]].map(([dx,dy],i)=>(
              <ellipse key={i} cx={60+dx} cy={71+dy} rx="8" ry="13"
                transform={`rotate(${i*60},${60+dx},${71+dy})`}
                fill="#C9A84C" opacity=".5"/>
            ))}
            {[0,72,144,216,288].map((a,i)=>{
              const rad=a*Math.PI/180;
              return <ellipse key={i} cx={60+9*Math.sin(rad)} cy={68-9*Math.cos(rad)} rx="5" ry="10"
                transform={`rotate(${a},${60+9*Math.sin(rad)},${68-9*Math.cos(rad)})`}
                fill="white" opacity=".9"/>;
            })}
            <ellipse cx="60" cy="66" rx="4.5" ry="9" fill="white"/>
          </svg> */}
          <div>
            <div style={styles.hotelName(scrolled)}>Shree Maya Comfort Inn</div>
            <div style={styles.tagline(scrolled)}>Experience true hospitality</div>
          </div>
        </div>

        <ul className="nav-links-wrap" style={styles.links}>
          {navLinks.map(([label, id]) => (
            <li key={id}>
              <button className="nav-link-item" style={styles.link(scrolled)} onClick={() => go(id)}>
                {label}
              </button>
            </li>
          ))}
        </ul>

        <button className="nav-cta-btn" style={styles.cta(scrolled)} onClick={() => go('contact')}>
          Book Now
        </button>

        <button className="nav-hamburger" style={{ display:'none', flexDirection:'column', gap:'5px', background:'none', border:'none', cursor:'pointer' }}
          onClick={() => setMenuOpen(true)}>
          {[0,1,2].map(i => (
            <div key={i} style={{ width:'24px', height:'1.5px', background: scrolled ? '#1B2F6E' : '#F2E8D9' }}/>
          ))}
        </button>
      </nav>

      {menuOpen && (
        <div className="mobile-menu">
          <button className="mobile-close" onClick={() => setMenuOpen(false)}>✕</button>
          {navLinks.map(([label, id]) => (
            <div key={id} className="mobile-link" onClick={() => go(id)}>{label}</div>
          ))}
          <button style={{...styles.cta(true), marginTop:'1rem'}} onClick={() => go('contact')}>Book Now</button>
        </div>
      )}
    </>
  );
}
